<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <a href="#" class="text-secondary text-decoration-none">
        <i class="fas fa-search"></i> Szukaj
      </a>
      <a href="#" class="text-primary text-decoration-none">
        <i class="fas fa-sync"></i> Odśwież
      </a>
    </div>
    <hr>
    <div class="row">
      <div class="d-lg-flex my-2">
        <h5>
          <router-link :to="{ name: 'UserList' }" class="text-decoration-none fw-bold">
            LISTA UŻYTKOWNIKÓW
          </router-link>
          <i class="fa-solid fa-circle-arrow-right mx-3"></i>
        </h5>
        <h5 class="fw-bold">
          EDYTUJ DANE UŻYTKOWNIKA
        </h5>
      </div>
    </div>
    <form @submit.prevent="updateUser" v-if="user && canEdit">
      <div class="mb-3">
        <label for="name" class="form-label">Imię</label>
        <input type="text" class="form-control" id="name" v-model="user.name">
      </div>
      <div class="mb-3">
        <label for="last-name" class="form-label">Nazwisko</label>
        <input type="text" class="form-control" id="last-name" v-model="user.lastName">
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input type="email" class="form-control" id="email" v-model="user.email">
      </div>
      <button class="btn btn-primary">
        Zatwierdź
      </button>
    </form>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'EditUser',
  components: { Navbar },
  data () {
    return {
      axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      user: null,
      canEdit: false,
      superAdmin: null,
      secondAdmin: null
    }
  },
  created () {
    this.fetchUser()
  },
  methods: {
    async fetchUser () {
      this.user = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}User/${this.$route.params.id}`, this.axiosConfig)).data

      const superAdminsEmails = ['s.kozanecki@growingeco.pl', 'd.mruk@growingeco.pl']
      const currentUserEmail = localStorage.getItem('email')

      if (this.user.email === localStorage.getItem('email') || superAdminsEmails.includes(currentUserEmail)) {
        this.canEdit = true
      }
    },

    async updateUser () {
      if (this.canEdit) {
        await axios.put(`${process.env.VUE_APP_API_BASE_URL}User/${this.$route.params.id}`, this.user, this.axiosConfig)
        await Swal.fire('Zaktualizowane dane użytkownika', '', 'success')
      }
    }
  }
}
</script>
